// src/api/sessionApi.js
import api from "./api";

/** ✅ Get the current (latest) session status */
export const getSessionStatus = async () => {
  // backend route: /api/core/session-status/
  const response = await api.get("/core/session-status/");
  return response.data;
};

/** ✅ Admin: toggle session open/close */
export const toggleSession = async (isOpen) => {
  // backend route: /api/core/sessions/toggle/
  const response = await api.post("/core/sessions/toggle/", { is_open: isOpen });
  return response.data;
};

/** ✅ Admin: fetch all sessions */
export const getAllSessions = async () => {
  // backend route: /api/core/sessions/
  const response = await api.get("/core/sessions/");
  return response.data;
};
